export default "<p>\n  admin-edit-tag-maps works!\n</p>\n";